<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>站桶员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序列号" align="center" prop="id" sortable width="150" fixed/>
      <el-table-column label="账号" align="center" prop="code" sortable width="150"/>
      <el-table-column label="站桶人员姓名" align="center" prop="name" sortable width="150"/>
      <el-table-column label="密码" align="center" prop="password" sortable width="150"/>
      <el-table-column label="手机号" align="center" prop="phone" sortable width="150"/>
      <el-table-column label="省份" align="center" prop="province" sortable width="150"/>
      <el-table-column label="城市" align="center" prop="city" sortable width="150"/>
      <el-table-column label="地址" align="center" prop="adds" sortable width="150"/>
      <el-table-column label="状态" align="center" prop="status" sortable width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.status==0">启用</span>
          <span v-if="scope.row.status==1">停用</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
        <el-form-item label="账号" prop="code">
          <el-input v-model="editForm.code" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="站桶人员姓名" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="省份" prop="province">
          <el-input v-model="editForm.province" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="城市" prop="city">
          <el-input v-model="editForm.city" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="地址" prop="adds">
          <el-input v-model="editForm.adds" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="状态(0-启用/1-停用)" prop="status">
          <el-input v-model="editForm.status" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { listAgent, getAgent, addAgent,updateAgent,saveAgent,delAgent } from '../../api/agent'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          id: 0,
          pid: 0,
          code: '',
          name: '',
          password: '',
          phone: '',
          province: '',
          city: '',
          adds: '',
          status:0,
          page: 1,
          limit: 10,
          token: localStorage.getItem('logintoken')
        },
        // rules表单验证
        rules: {
          password: [{ required: true, message: '请输入', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入', trigger: 'blur' }],
          code: [{ required: true, message: '请输入', trigger: 'blur' }],
          name: [{ required: true, message: '请输入', trigger: 'blur' }],
          adds: [{ required: true, message: '请输入', trigger: 'blur' }],
          status: [{ required: true, message: '请输入', trigger: 'blur' }]
        },
        formInline: {
          page: 1,
          limit: 10,
          token: localStorage.getItem('logintoken')
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    mounted() {
      this.getdata(this.editForm)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取列表
      getdata(parameter) {
        this.loading = true
        parameter.limit= this.formInline.limit
        parameter.size= this.formInline.page
        // parameter.limit=5;
        // parameter.page=1;
        console.log("parameter:"+JSON.stringify(parameter))
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        listAgent(parameter)
          .then(res => {
            console.log("parameter:"+parameter)
            this.loading = false
            if (res.status != 1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.count
              console.log("分页参数："+this.pageparm.currentPage+","+this.pageparm.pageSize+","+this.pageparm.total)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.id = row.id
          // this.editForm.pid = row.pid
          this.editForm.code = row.code
          this.editForm.name = row.name
          this.editForm.password = row.password
          this.editForm.phone = row.phone
          this.editForm.province = row.province
          this.editForm.city = row.city
          this.editForm.adds = row.adds
          this.editForm.status = row.status
        } else {
          this.title = '添加'
          // this.editForm.pid = ''
          this.editForm.code = ''
          this.editForm.name = ''
          this.editForm.password = ''
          this.editForm.phone = ''
          this.editForm.province = ''
          this.editForm.city = ''
          this.editForm.adds = ''
          this.editForm.status = ''
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        console.log("1111111111111111:"+JSON.stringify(editData))
        this.$refs[editData].validate(valid => {
          if (valid) {
            saveAgent(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.status==1) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            row.limit=5;
            row.page=1;
            console.log("row.id:"+JSON.stringify(row))
            delAgent(row)
              .then(res => {
                if (res.status==1) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/views/agent/Agent.vue